module.exports = __webpack_public_path__ + "img/oseibo_bg.b588c0e8.jpg";